import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { getBackendURL, useBackendDomain, useImageToken } from '../hooks/useBackendDomain.js';

const imageRegex: RegExp = /!\[(.*?)\]\((.*?)\)/g;

function appendTokenToImageUrls(markdown: string, token: string | null, domain: string | null): string {
	// Regular expression to match Markdown image syntax ![alt](url)

	// Replace function to append the token to the image URLs
	const replaceFunction = (match: string, alt: string, url: string): string => {
		// Append the token parameter to the image URL
		const newUrl: string = getBackendURL(url, domain, token, '_jwt_image_token');

		// Replace the original URL with the new URL
		return `![${alt}](${newUrl})`;
	};

	// Replace all Markdown image URLs with the new URLs
	return markdown.replace(imageRegex, replaceFunction);
}

// Render post contents as HTML.
export const PostContentsToHTML: React.FC<{ children: string }> = ({ children }) => {
	const [domain] = useBackendDomain();

	const token = useImageToken();

	const replaced = appendTokenToImageUrls(children, token, domain);
	return (
		<div style={{ overflow: 'hidden' }}>
			<ReactMarkdown rehypePlugins={[remarkGfm]}>{replaced}</ReactMarkdown>
		</div>
	);
};
